<template>
  <w-setting-sliding-popup ref="slidingPopup" :title="targetTitle" width="750px">
    <div slot="content">
      <el-form :model="formData" ref="formData" :rules="rules">
        <el-row type="flex" :gutter="15">
          <el-col :span="12">
            <el-form-item label="벤더 선택" prop="objCompanyName">
              <el-select @change="onChangeObjCompany" style="width: 100%;" v-model="formData.objCompanyId" :disabled="popupMode === 'update'">
                <el-option v-for="item in objCompanyModelList" :label="item.objCompanyName" :value="item.objCompanyId" :key="item.objCompanyId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="모델 선택" prop="objProductId">
              <el-select ref="selectProduct" style="width: 100%;" v-model="formData.objProductId" :disabled="popupMode === 'update'">
                <el-option v-for="item in objProductList" :label="item.objProductId" :value="item.objProductId" :key="`${item.objProductId}${item.objtypeId}`"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="15" style="padding-top: 30px;">
          <el-col :span="12">
            <el-form-item label="단종일" prop="eolDate">
              <el-date-picker style="width: 100%;" v-model="formData.eolDate" type="date" placeholder="단종 날짜를 선택해주세요"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="서비스 종료일" prop="eosDate">
              <el-date-picker style="width: 100%;" v-model="formData.eosDate" type="date" placeholder="서비스 종료 날짜를 선택해주세요"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" :gutter="15" style="padding-top: 30px;">
          <el-col :span="12">
            <el-form-item label="교체주기(년)" prop="changePeriod">
              <el-input v-model="formData.changePeriod"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="URL" prop="url">
              <el-input placeholder="http:// 또는 https:// 를 입력해주세요" v-model="formData.url"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid"  @click="onAddDeviceLifeCycle">저장</el-button>
      <el-button size="large" @click="clickCloseBtn">취소</el-button>
    </div>
  </w-setting-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import { cloneDeep, isNaN, isUndefined } from 'lodash';
import commonAPI from '@/api/config/common';
import NetdeviceLifeCycleSettingsAPI from '@/api/settings/netdevice/netdevice-life-cycle-settings';

export default {
  name: 'WDeviceLifeSlidingPopup',
  data() {
    return {
      rules: {
        objCompanyId: { required: true, trigger: 'blur', message: '값을 입력해주세요' },
        objProductId: { required: true, trigger: 'blur', message: '값을 입력해주세요' },
        changePeriod: { trigger: 'blur', validator: this.checkNumberValidate },
      },
      formData: {
        objCompanyId: '',
        objProductId: '',
        eolDate: '',
        eosDate: '',
        url: null,
        changePeriod: null,
      },
      targetTitle: '',
      objCompanyModelList: [],
      objProductList: [],
      objProductListOrigin: [],
      popupMode: null,
    };
  },
  mounted() {
    // 벤더
    commonAPI.getObjCompanyListHavingModel({}).then((res) => {
      this.objCompanyModelList = res.data.data;
    });
    commonAPI.getObjProductList({}).then((res) => {
      this.objProductList = res.data.data;
      this.objProductListOrigin = cloneDeep(this.objProductList);
    });
  },
  methods: {
    open(item) {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.$refs.formData.resetFields();
        if (item) {
          this.popupMode = 'update';
          this.formData = cloneDeep(item);
          this.formDataOrigin = cloneDeep(this.formData);
          this.targetTitle = 'EOL/EOS 정보';
        } else {
          this.popupMode = 'add';
          this.targetTitle = 'EOL/EOS 추가';
          this.formData.objCompanyId = this.objCompanyModelList[0].objCompanyId;
          this.onChangeObjCompany();
        }
      });
    },
    onAddDeviceLifeCycle() {
      this.$refs.formData.validate().then((res) => {
        if (res) {
          if (this.popupMode === 'add') {
            NetdeviceLifeCycleSettingsAPI.insertDeviceModelList(this.formData).then((response) => {
              if (response.data.success) {
                this.$emit('load-data');
                this.clickCloseBtn();
                this.$message(msgUtil.getCustomMsgData('저장하였습니다.'));
              } else {
                this.$message(msgUtil.getCustomMsgData('중복된 장비모델이 존재합니다.'));
                this.$refs.selectProduct.focus();
              }
            });
          } else {
            NetdeviceLifeCycleSettingsAPI.updateDeviceModelList(this.formData).then((response) => {
              if (response.data.success) {
                this.$emit('load-data');
                this.clickCloseBtn();
                this.$message(msgUtil.getCustomMsgData('저장하였습니다.'));
              } else {
                this.$message(msgUtil.getCustomMsgData('중복된 장비모델이 존재합니다.'));
                this.$refs.selectProduct.focus();
              }
            });
          }
        }
      }).catch(() => {});
    },
    checkNumberValidate(rule, value, callback) {
      if (value === '') {
        delete this.formData.changePeriod;
        callback();
      } else if (isUndefined(value) || !isNaN(Number(value))) {
        callback();
      } else {
        callback(new Error('숫자 값을 입력해주세요'));
      }
    },
    clickCloseBtn() {
      this.$refs.slidingPopup.close();
    },
    // 선택한 objCompany 값에 따라 productList를 filter한다.
    onChangeObjCompany() {
      this.objProductList = cloneDeep(this.objProductListOrigin).filter((c) => c.objCompanyId === this.formData.objCompanyId);
      this.formData.objProductId = this.objProductList[0].objProductId;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/netdevice/DeviceModelSettings/DeviceLifeCycleManagement/popup/DeviceLifeCycleSlidingPopup.vue